// Private Vars

export default function VendorManagementAdminDirectiveController(
  $q,
  $scope,
  editMasterVendorDialog,
  ssDialogService,
  vmDataService,
) {
  const vm = this;
  vm.appIsLoaded = false;
  vm.masterVendors = [];
  vm.handleShowAddMasterVendorClick = handleShowAddMasterVendorClick;

  _activate();

  function _activate() {
    // const dfdActivate = $q.defer();

    _initEventListeners();
    _refreshMasterVendors().then(() => {
      vm.appIsLoaded = true;
      // dfdActivate.resolve();
    });

    // return dfdActivate.promise;
  }

  function handleShowAddMasterVendorClick($event) {
    ssDialogService.dialogs.vendorManagement.editMasterVendorDialog = ssDialogService.alert(
      editMasterVendorDialog.getOptions($event, {
        masterVendor: {
          masterVendorId: 0,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.vendorManagement.editMasterVendorDialog);
  }

  function _refreshMasterVendors() {
    const dfdItem = $q.defer();
    vmDataService.getMasterVendors().then((response) => {
      vm.masterVendors = response.data.result;
      dfdItem.resolve();
    });

    return dfdItem.promise;
  }

  function _initEventListeners() {
    $scope.$on(
      'refreshVMAVendors',
      _refreshMasterVendors
    );
  }
}

VendorManagementAdminDirectiveController.$inject = [
  '$q',
  '$scope',
  'editMasterVendorDialog',
  'ssDialogService',
  'vmDataService'
];
